import { AnyAction } from 'redux';
import {
  createActionHomeAddFeaturedPlaylists,
  createActionHomeAddNewReleasedAlbums,
  createActionHomeAddTopArtists,
  createActionHomeAddTopTracks,
  createActionHomeErrorFeaturedPlaylists,
  createActionHomeErrorNewReleasedAlbums,
  createActionHomeErrorTopArtists,
  createActionHomeErrorTopTracks,
  createActionHomeLoadingFeaturedPlaylists,
  createActionHomeLoadingNewReleasedAlbums,
  createActionHomeLoadingTopArtists,
  createActionHomeLoadingTopTracks,
} from '../actions/home';
import { IAlbumDetails } from '#/types/API/newReleasedAlbums';
import { ITopArtist } from '#/types/API/topArtists';
import { ITopTrack } from '#/types/API/topTracks';
import { ILoadingError } from '#/types/global';
import { IFeaturedPlaylistsResponse } from '#/types/API/featuredPlaylists';

interface IState {
  newReleasedAlbums: IAlbumDetails[] | ILoadingError;
  topArtists: ITopArtist[] | ILoadingError;
  topTracks: ITopTrack[] | ILoadingError;
  featuredPlaylists: IFeaturedPlaylistsResponse | ILoadingError; 
}

const initialState: IState = {
  newReleasedAlbums: { _loading: true, _error: false },
  topArtists: { _loading: true, _error: false },
  topTracks: { _loading: true, _error: false },
  featuredPlaylists: { _loading: true, _error: false },
};

const home = (state: IState = initialState, action: AnyAction): IState => {
  if (createActionHomeAddNewReleasedAlbums.doesMatch(action)) {
    return { ...state, newReleasedAlbums: [...action.payload] };
  }

  if (createActionHomeLoadingNewReleasedAlbums.doesMatch(action)) {
    return {
      ...state,
      newReleasedAlbums: { ...state.newReleasedAlbums, _loading: true },
    };
  }

  if (createActionHomeErrorNewReleasedAlbums.doesMatch(action)) {
    return {
      ...state,
      newReleasedAlbums: { ...state.newReleasedAlbums, _error: true },
    };
  }

  if (createActionHomeAddTopArtists.doesMatch(action)) {
    return { ...state, topArtists: [...action.payload] };
  }

  if (createActionHomeLoadingTopArtists.doesMatch(action)) {
    return { ...state, topArtists: { ...state.topArtists, _loading: true } };
  }

  if (createActionHomeErrorTopArtists.doesMatch(action)) {
    return { ...state, topArtists: { ...state.topArtists, _error: true } };
  }

  if (createActionHomeAddTopTracks.doesMatch(action)) {
    return { ...state, topTracks: [...action.payload] };
  }

  if (createActionHomeLoadingTopTracks.doesMatch(action)) {
    return { ...state, topTracks: { ...state.topTracks, _loading: true } };
  }

  if (createActionHomeErrorTopTracks.doesMatch(action)) {
    return { ...state, topTracks: { ...state.topTracks, _error: true } };
  }

  if (createActionHomeAddFeaturedPlaylists.doesMatch(action)) {
    return { ...state, featuredPlaylists: action.payload };
  }

  if (createActionHomeLoadingFeaturedPlaylists.doesMatch(action)) {
    return { ...state, featuredPlaylists: { ...state.featuredPlaylists, _loading: true } };
  }

  if (createActionHomeErrorFeaturedPlaylists.doesMatch(action)) {
    return { ...state, featuredPlaylists: { ...state.featuredPlaylists, _error: true } };
  }

  return state;
};

export default home;
